import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-addmeasureitems',
  templateUrl: './addmeasureitems.component.html',
  styleUrls: ['./addmeasureitems.component.scss']
})
export class AddmeasureitemsComponent implements OnInit {
  AddMeasurerItemsForm: FormGroup;
  clients: any;
  clientstofilter: any;
  dataSource: any;
  displayedColumns: string[] = [
    "ItemName",
    "Code",
    "ItemType",
    "Branch",
    "Action"
  ];
  data: object[] = [];
  update: boolean;
  editmode: boolean;
  ClientId: any;
  AllBranchs: any[] = [];
  MeasurerItems: any;
  MeasurerItemstofilter: any;
  MeasurerItemsBranch: any[] = [];
  selectedTimes:any[]=[]
  // ItemTypes: any[] = [
  //   { id: 1, name: 'Refrigerators' },
  //   { id: 2, name: 'Freezers' },
  //   { id: 3, name: 'Vegetable Sanitation' },
  //   { id: 4, name: 'Oil' },
  //   { id: 5, name: 'Dry Store' },
  // ];
  ItemTypes: any[] =[]
  MeasurerItemsId: any;
  UserInfo: any;
  Country: any;
  Iot: boolean=false;
  Times:any[]=[]
  constructor(
    private _formBuilder: FormBuilder,
    public GeneralService: GeneralService
  ) {
    this.UserInfo = JSON.parse(localStorage.getItem('currentuser'));
    const ClientData = JSON.parse(localStorage.getItem('ClientData'));
    this.Country = ClientData.country;
    this.ClientId = this.UserInfo.clientid;
  }

  ngOnInit() {
    this.editmode = false;
    this.initForm();
    this.getallMeasurerItems();
    this.GetAllBranchs();
    this.GetAllItemType()
    this.generateTimeArray();
  }

  initForm() {
    this.AddMeasurerItemsForm = this._formBuilder.group({
      ItemName: ['', Validators.required],
      Code: ['', Validators.required],
      ItemType: [[], Validators.required],
      Branch: [[], Validators.required],
      DeviceNickName: [''],
      DeviceId: [''],
      MonitoringTimes:['',],
      EmergancyPhoneNumber: this._formBuilder.array([]),
      isIot: [false],
    });
  
  }

  get EmergancyPhoneNumber() {
    return this.AddMeasurerItemsForm.get('EmergancyPhoneNumber') as FormArray;
  }


  removePhoneNumber(index: number) {
    this.EmergancyPhoneNumber.removeAt(index);
    this.AddMeasurerItemsForm.updateValueAndValidity(); // Update form validity
  }
// Add this getter to your component
get isFormValid(): boolean {
  const form = this.AddMeasurerItemsForm;
  const isIot = form.get('isIot').value;
  
  if (!isIot) {
    return form.get('ItemName').valid && 
           form.get('Code').valid && 
           form.get('ItemType').valid && 
           form.get('Branch').valid;
  }
  
  return form.valid && this.EmergancyPhoneNumber.length > 0;
}
  // In the onIotChange method, update the validation handling:
onIotChange(event: any) {
  const controls = ['DeviceNickName', 'DeviceId','MonitoringTimes'];
  if (event.checked) {
    this.Iot = true;
    // Add validators to IoT fields
    controls.forEach(control => {
      this.AddMeasurerItemsForm.get(control).setValidators([Validators.required]);
      this.AddMeasurerItemsForm.get(control).updateValueAndValidity();
    });
    // Add at least one phone number when IoT is enabled
    if (this.EmergancyPhoneNumber.length === 0) {
      this.addPhoneNumber();
    }
  } else {
    this.Iot = false;
    // Clear validators from IoT fields
    controls.forEach(control => {
      this.AddMeasurerItemsForm.get(control).clearValidators();
      this.AddMeasurerItemsForm.get(control).reset();
      this.AddMeasurerItemsForm.get(control).updateValueAndValidity();
    });

    // Clear all phone numbers
    while (this.EmergancyPhoneNumber.length !== 0) {
      this.EmergancyPhoneNumber.removeAt(0);
    }
  }

  this.AddMeasurerItemsForm.updateValueAndValidity();
}

// Update the addPhoneNumber method:
addPhoneNumber() {
  const phoneControl = this._formBuilder.control('', Validators.required);
  this.EmergancyPhoneNumber.push(phoneControl);
}
onPhoneInput(event: any, index: number) {
  const value = event.target.value;
  
  // Optional: Add phone number validation here
  const validPhone = /^\d+$/.test(value);
  if (!validPhone) {
    event.target.value = value.replace(/[^\d]/g, '');
  }
}
  GetAllBranchs() {
    this.GeneralService.getBranchByClientId(this.ClientId).then(res => {
      this.AllBranchs = res;
    });
  }
  GetAllItemType() {
    this.GeneralService.getallItemType().subscribe(res => {
      this.ItemTypes = res;
    });
  }
  private generateTimeArray() {
    for (let i = 0; i < 24; i++) {
      // Pad the hour with leading zero if needed
      const hour = i.toString().padStart(2, '0');
      this.Times.push(`${hour}:00`);
    }
    console.log(this.Times)
  }
  isTimeDisabled(): boolean {
    return this.selectedTimes?.length===6;
  }
  getallMeasurerItems() {
    const ClientId = this.ClientId;
    this.GeneralService.getMeasurerItemsbyclientid(ClientId).then(items => {
      items.map(res => {
        if (res.EmergancyPhoneNumber && Array.isArray(res.EmergancyPhoneNumber)) {
          res.EmergancyPhoneNumber = res.EmergancyPhoneNumber.map(phone => phone.replace(/^\+20|\+966/, ''));
        } else {
          res.EmergancyPhoneNumber = []; // تعيين قيمة افتراضية كمصفوفة فارغة
        }
      });
      this.MeasurerItems = items;
      this.MeasurerItemstofilter = items;
    });
  }

  getBranchName(id) {
    return this.AllBranchs.filter(x => x.id == id)[0]?.name;
  }

  getItemTypeName(id) {
    return this.ItemTypes.filter(x => x.id == id)[0]?.name;
  }

  get fc() {
    return this.AddMeasurerItemsForm.controls;
  }

  InsertMeasurerItems() {

  
    let CountryCode;
    if (this.Country == 'Egypt') {
      CountryCode = '+20';
    } else if (this.Country == 'Saudi Arabia') {
      CountryCode = '+966';
    }
  
    // Check if there are phone numbers before mapping
    const phoneNumbers = this.AddMeasurerItemsForm.get('isIot').value ? 
      this.EmergancyPhoneNumber.value.map(phone => CountryCode + phone) : 
      [];
  
  
    const data = {
      ItemName: this.AddMeasurerItemsForm.get("ItemName").value,
      Code: this.AddMeasurerItemsForm.get("Code").value,
      ItemType: this.AddMeasurerItemsForm.get("ItemType").value,
      clientid: this.ClientId,
      Branch: this.AddMeasurerItemsForm.get("Branch").value,
      DeviceNickName: this.AddMeasurerItemsForm.get("DeviceNickName").value,
      DeviceId: this.AddMeasurerItemsForm.get("DeviceId").value,
      EmergancyPhoneNumber: phoneNumbers,
      Iot:this.Iot,
      MonitoringTimes:this.selectedTimes
    };
  
  
    this.GeneralService.addMeasurerItemsForClient(data).then(res => {
      Swal.fire({
        icon: "success",
        title: "Success",
        showConfirmButton: false,
        timer: 1500,
      });
      this.getallMeasurerItems();
      this.AddMeasurerItemsForm.reset();
      // Reset the FormArray as well
      while (this.EmergancyPhoneNumber.length !== 0) {
        this.EmergancyPhoneNumber.removeAt(0);
      }
    });
  }

  addMeasurerItems() {
    if (this.AddMeasurerItemsForm.status == "VALID") {
      if (this.update == true) {
        this.UpdateMeasurerItems();
      } else {
        this.InsertMeasurerItems();
      }
    } else {
      this.AddMeasurerItemsForm.markAllAsTouched();
    }
  }

  Edit(item) {
    this.MeasurerItemsId = item.id;
    this.editmode = true;
    this.update = true;

    // const hasIotData = item.DeviceNickName || item.DeviceId || item.EmergancyPhoneNumber;

    // Clear existing phone numbers
    while (this.EmergancyPhoneNumber.length !== 0) {
      this.EmergancyPhoneNumber.removeAt(0);
    }

    // Add phone numbers from the item
    if (item.EmergancyPhoneNumber && item.EmergancyPhoneNumber.length > 0) {
      item.EmergancyPhoneNumber.forEach(phone => {
        this.EmergancyPhoneNumber.push(this._formBuilder.control(phone.replace(/^\+20|\+966/, ''), Validators.required));
      });
    }

    this.AddMeasurerItemsForm.patchValue({
      ItemName: item.ItemName,
      Code: item.Code,
      ItemType: item.ItemType,
      Branch: item.Branch,
      isIot: item.Iot,
      DeviceNickName: item.DeviceNickName,
      DeviceId: item.DeviceId,
    });
if(item.MonitoringTimes){
  this.selectedTimes=item.MonitoringTimes
}
    if (item.Iot) {
      this.onIotChange({ checked: true });
    }
  }

  UpdateMeasurerItems() {
    let CountryCode;
    if (this.Country == 'Egypt') {
      CountryCode = '+20';
    } else if (this.Country == 'Saudi Arabia') {
      CountryCode = '+966';
    }

    const phoneNumbers = this.EmergancyPhoneNumber.value.map(phone => CountryCode + phone);

    const data = {
      ItemName: this.AddMeasurerItemsForm.get("ItemName").value,
      Code: this.AddMeasurerItemsForm.get("Code").value,
      ItemType: this.AddMeasurerItemsForm.get("ItemType").value,
      clientid: this.ClientId,
      Branch: this.AddMeasurerItemsForm.get("Branch").value,
      DeviceNickName: this.AddMeasurerItemsForm.get("DeviceNickName").value,
      DeviceId: this.AddMeasurerItemsForm.get("DeviceId").value,
      EmergancyPhoneNumber: phoneNumbers, // Array of phone numbers
      Iot:this.Iot,
      MonitoringTimes:this.selectedTimes
    };

    this.GeneralService.UpdateMeasurerItems(this.MeasurerItemsId, data).then((res) => {
      this.AddMeasurerItemsForm.reset();
      this.MeasurerItems = [];
      this.editmode = false;
      this.update = false;
    }).then(r => {
      Swal.fire({
        icon: "success",
        title: "Success",
        showConfirmButton: false,
        timer: 1500,
      });
      this.getallMeasurerItems();
    });
  }

  DeleteMeasurer(item) {
    Swal.fire({
      title: " Warning !",
      text: "Are you sure to delete this MeasurerItems?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#7364f6',
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
      cancelButtonText: "Back",
    }).then((result) => {
      if (result.isConfirmed) {
        this.GeneralService.DeleteMeasurerItems(item.id).then(
          (res) => {
            this.MeasurerItems = [];
            Swal.fire({
              icon: "success",
              title: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            this.getallMeasurerItems();
          },
          (err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.error,
            });
          }
        );
      }
    });
  }
}